import { render } from "./confirm-order.vue?vue&type=template&id=633f208e&scoped=true&ts=true"
import script from "./confirm-order.vue?vue&type=script&lang=ts"
export * from "./confirm-order.vue?vue&type=script&lang=ts"

import "./confirm-order.vue?vue&type=style&index=0&id=633f208e&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-633f208e"]])

export default __exports__